module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('span', {
    class: _vm.estilo,
    on: {
      "click": function($event) {
        _vm.mostra = !_vm.mostra
      }
    }
  }, [(!_vm.mostra) ? _c('i', {
    staticClass: "fa fa-chevron-circle-down",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-chevron-circle-up",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mostra),
      expression: "mostra"
    }]
  }, [_vm._t("default")], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78997fb6","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/esconde-div/index.vue
// module id = r65U
// module chunks = 5